export enum MetodosPagamento {
  CartaoCredito = 'Cartão de Crédito',
  Boleto = 'Boleto',
  Isencao = 'Isencao',
  Pix = 'Pix'
}
